'use strict';

import {convertDataVToVue} from '../apply_vue_data_directives.js';

export class Vipprofileguidecard {
	constructor(component_id) {
		this.id = component_id;
		this.vars = yalwa.v.components[this.id];
		this.$root = jQuery(`.js-${this.id}`);
	}

	init() {
		// the click interactions are handled by the Vue component
	}

	vue_setup(Vue) {
		const ythis = this;

		if (!this.$root) {
			console.error(`Vue JS container not found for ID: ${this.id}`);
			return {};
		}

		const rootx = document.querySelector(`.js-${this.id}`);
		const template = `${convertDataVToVue(rootx)}`;

		return Vue.defineComponent({
			delimiters: ['[[', ']]'],
			name: this.id,
			template,
			setup() {
				const initial_pct = ythis.vars?.data?.pct ?? 0;
				const completion_pct = Vue.ref(initial_pct);
				const sections = Vue.ref(ythis.vars?.data?.sections ?? 0);
				const expanded = Vue.ref(false);
				const inline = Vue.ref(initial_pct > 50);
				const minimized = Vue.ref(false);

				// profile section saves (ajaxservice profileupdate) deliver fresh
				// completion state; update the card without a page reload
				const on_state = (event) => {
					const state = event.detail;

					if (!state) {
						return;
					}
					completion_pct.value = state.pct;
					sections.value = state.sections;
					inline.value = state.pct > 50;
				};
				document.addEventListener('vip_guide_state', on_state);

				const bar_color = Vue.computed(() => {
					if (completion_pct.value <= 40) {
						return 'red';
					}
					if (completion_pct.value <= 70) {
						return 'orange';
					}
					return 'green';
				});

				const bar_style = Vue.computed(() => ({
					width: completion_pct.value + '%',
				}));

				const fill_class = Vue.computed(() => ({
					'vipprofileguidecard__fill--red': bar_color.value === 'red',
					'vipprofileguidecard__fill--orange': bar_color.value === 'orange',
					'vipprofileguidecard__fill--green': bar_color.value === 'green',
				}));

				const ring_style = Vue.computed(() => ({
					'--pct': completion_pct.value,
				}));

				const ring_class = Vue.computed(() => ({
					'vipprofileguidecard__ring--red': bar_color.value === 'red',
					'vipprofileguidecard__ring--orange': bar_color.value === 'orange',
					'vipprofileguidecard__ring--green': bar_color.value === 'green',
				}));

				const root_class = Vue.computed(() => ({
					'vipprofileguidecard--inline': inline.value,
					'vipprofileguidecard--minimized': minimized.value,
					'js-active': expanded.value,
				}));

				return {
					completion_pct,
					sections,
					expanded,
					inline,
					minimized,
					bar_style,
					fill_class,
					ring_style,
					ring_class,
					root_class,
					toggle() {
						expanded.value = !expanded.value;
					},
					minimize() {
						minimized.value = true;
					},
					restore() {
						minimized.value = false;
					},
					open_complete_profile_dialog() {
						const dialog = yalwa.v.component_instances?.['dialog_vipguidewhy'];
						if (dialog) {
							document.dispatchEvent(new CustomEvent('vip_guide_dialog_view', {detail: {view: 'checklist'}}));
							jQuery(`.js-dialog_vipguidewhy`).appendTo('body');
							dialog.show();
						}
					},
					open_why() {
						const dialog = yalwa.v.component_instances?.['dialog_vipguidewhy'];
						if (dialog) {
							document.dispatchEvent(new CustomEvent('vip_guide_dialog_view', {detail: {view: 'why'}}));
							jQuery(`.js-dialog_vipguidewhy`).appendTo('body');
							dialog.show();
						}
					},
				};
			},
		});
	}
}
